import { useState, useEffect } from 'react';

export default function FullPageDropZone({ onDropFiles }: { onDropFiles: (files: File[]) => void }) {
    const [isDragging, setIsDragging] = useState(false);
    let dragCounter = 0;

    const handleDragEnter = (e: DragEvent) => {
        e.preventDefault();
        dragCounter++;
        setIsDragging(true);
    };

    const handleDragLeave = (e: DragEvent) => {
        e.preventDefault();
        dragCounter--;
        if (dragCounter === 0) {
            setIsDragging(false);
        }
    };

    const handleDragOver = (e: DragEvent) => {
        e.preventDefault();
    };

    const handleDrop = (e: DragEvent) => {
        e.preventDefault();
        dragCounter = 0;
        setIsDragging(false);

        if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
            const files = e.dataTransfer ? Array.from(e.dataTransfer.files) : [];
            onDropFiles(files);
        }
    };

    useEffect(() => {
        window.addEventListener('dragenter', handleDragEnter);
        window.addEventListener('dragleave', handleDragLeave);
        window.addEventListener('dragover', handleDragOver);
        window.addEventListener('drop', handleDrop);

        return () => {
            window.removeEventListener('dragenter', handleDragEnter);
            window.removeEventListener('dragleave', handleDragLeave);
            window.removeEventListener('dragover', handleDragOver);
            window.removeEventListener('drop', handleDrop);
        };
    }, []);

    return (
        <>
            {isDragging && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0, left: 0, right: 0, bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.3)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#fff',
                        fontSize: '24px',
                        pointerEvents: 'none',
                    }}
                >
                    Drop files to upload
                </div>
            )}
        </>
    );
};
